<template>
  <div>
    <el-dialog title="脑图" :visible.sync="mindMapVisible" width="65%" :before-close="dialogBeforeClose">
        <div class="dialog-content">
          <div class="button-list" v-if="activeData.data">
            <!-- <el-button type="primary" @click="$emit('toLocation', activeData.data.id)">跳转</el-button> -->
            <!-- <el-button type="primary" size="mini" @click="$emit('deleteMind', activeData.data.id)">移除</el-button> -->
            <!-- <el-button type="primary" size="mini" @click="$emit('deleteMind', activeData.data.id)">增加子节点</el-button> -->
            <el-button type="primary" size="mini" @click="deleteMind(activeData.data.id)">移除</el-button>
            <el-button v-if="activeData.data.isRoot != 1" type="primary" size="mini" @click="addMind">增加兄弟节点</el-button>
            <el-button type="primary" size="mini" @click="addChildMind">增加子节点</el-button>
          </div>
          <div id="mindMapContainer"></div>
          <div class="mind-map-bottom">
            <el-button type="text" @click="resetLayout">
              <span class="icon el-icon-aim"></span>
            </el-button>
            <el-button type="text" @click="exportImage">
              <span class="icon el-icon-download"></span>
            </el-button>
          </div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import { getMindMap, setMindMap } from "@/utils/storage";
import MindMap from 'simple-mind-map'
import MiniMap from 'simple-mind-map/src/plugins/MiniMap.js'
import Watermark from 'simple-mind-map/src/plugins/Watermark.js'
import KeyboardNavigation from 'simple-mind-map/src/plugins/KeyboardNavigation.js'
import ExportPDF from 'simple-mind-map/src/plugins/ExportPDF.js'
import ExportXMind from 'simple-mind-map/src/plugins/ExportXMind.js'
import Export from 'simple-mind-map/src/plugins/Export.js'
import Drag from 'simple-mind-map/src/plugins/Drag.js'
import Select from 'simple-mind-map/src/plugins/Select.js'
import AssociativeLine from 'simple-mind-map/src/plugins/AssociativeLine.js'
import TouchEvent from 'simple-mind-map/src/plugins/TouchEvent.js'
import NodeImgAdjust from 'simple-mind-map/src/plugins/NodeImgAdjust.js'
import SearchPlugin from 'simple-mind-map/src/plugins/Search.js'
import Painter from 'simple-mind-map/src/plugins/Painter.js'
// import Formula from 'simple-mind-map/src/plugins/Formula.js'
import RainbowLines from 'simple-mind-map/src/plugins/RainbowLines.js'
import Demonstrate from 'simple-mind-map/src/plugins/Demonstrate.js'
import OuterFrame from 'simple-mind-map/src/plugins/OuterFrame.js'
// // 注册插件
MindMap.usePlugin(MiniMap)
  .usePlugin(Watermark)
  .usePlugin(Drag)
  .usePlugin(KeyboardNavigation)
  .usePlugin(ExportPDF)
  .usePlugin(ExportXMind)
  .usePlugin(Export)
  .usePlugin(Select)
  .usePlugin(AssociativeLine)
  .usePlugin(NodeImgAdjust)
  .usePlugin(TouchEvent)
  .usePlugin(SearchPlugin)
  .usePlugin(Painter)
  // .usePlugin(Formula)
  .usePlugin(RainbowLines)
  .usePlugin(Demonstrate)
  .usePlugin(OuterFrame)

export default {
  name: "mindMap",
  props: {
    mindMapVisible: {
      type: Boolean,
      default: false
    },
    mindMapData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      mindMap: null,
      activeData: {},
      editId: ''
    }
  },
  watch: {
    mindMapVisible(newVal) {
      if(newVal) {
        this.$nextTick(() => {
          let data = JSON.parse(JSON.stringify(this.mindMapData));
          let _this = this;
          if(!this.mindMap) {
            // 创建脑图
            this.mindMap = new MindMap({
              el: document.getElementById('mindMapContainer'),
              data,
              fitPadding: 20,
              exportPaddingX: 20,
              exportPaddingY: 50,
              isUseCustomNodeContent: false,
              customCreateNodeContent: (node) => {
                console.log(node)
                return false;
                let div = document.createElement('div');
                div.className = 'mind-map-item';
                div.id = `mind-map-${node.nodeData.data.id}`;
                if(node.nodeData.data.type === 'highlight') {
                  // 高亮的脑图节点样式
                  // console.log(_this.editId, node.nodeData.data.id)
                  // if(_this.editId === node.nodeData.data.id) {
                  //   div.contentEditable = "true";
                  //   div.focus()
                  //   var selection = getSelection()
                  //   var range = document.createRange()
                  //   // 光标对象的范围界定为新建的表情节点
                  //   range.selectNodeContents(div)
                  //   // 光标位置定位在表情节点的最大长度
                  //   range.setStart(div, div.length)
                  //   // 使光标开始和光标结束重叠
                  //   range.collapse(true)
                  //   // 清除选定对象的所有光标对象
                  //   selection.removeAllRanges()
                  //   // 插入新的光标对象
                  //   selection.addRange(range)
                  // }
                  div.innerHTML = node.nodeData.data.text;
                }else if(node.nodeData.data.type === 'note') {
                  // 笔记的脑图节点样式
                  div.innerHTML = `
                      <div class="mind-map-item-selected">${ node.nodeData.data.text }</div>
                      ${ node.nodeData.data.note }
                  `
                }else{
                  // 其他内容的脑图节点样式
                  if(!node.parent) {
                    div.className = 'mind-map-item mind-map-item-main'
                  }
                  div.innerHTML = node.nodeData.data.text;
                }
                return div
              }
            });
            this.mindMap.on('draw_click', () => {
              this.activeData = {}
            })
            // 激活操作脑图内容
            this.mindMap.on('node_active', (that, e) => {
              if(that) {
                this.activeData = that.nodeData
                console.log(that.parent)
              }else{
                this.activeData = {}
                this.mindMap.execCommand('CLEAR_ACTIVE_NODE')
              }
            })
            // 脑图节点双击事件
            this.mindMap.on('node_dblclick', (that, e) => {
              console.log(that)
              return false
              this.editId = `mind-map-${that.nodeData.data.id}`;
              let div = document.getElementById(this.editId)
              console.log(div)
              
              
              let newDiv = document.createElement('div');
              // div.contenteditable = "true";
              newDiv.setAttribute('contenteditable', 'true');
              newDiv.innerText = div.innerText
              this.$forceUpdate()
              
              div.focus()
              // var selection = getSelection()
              // var range = document.createRange()
              // // 光标对象的范围界定为新建的表情节点
              // range.selectNodeContents(div)
              // // 光标位置定位在表情节点的最大长度
              // range.setStart(div, div.length)
              // // 使光标开始和光标结束重叠
              // range.collapse(true)
              // // 清除选定对象的所有光标对象
              // selection.removeAllRanges()
              // // 插入新的光标对象
              // selection.addRange(range)
              // this.mindMap.setMode('edit')
              // this.mindMap.updateData(data)
            })
            
            // 节点树渲染完毕 自适应显示整体脑图
            this.mindMap.on('node_tree_render_end', () => {
              this.mindMap.view.fit()
            })
            // this.mindMap.on('hide_text_edit', () => {
            //   this.updateData()
            // })
            this.mindMap.on('data_change', () => {
              // this.mindMap.execCommand('CLEAR_ACTIVE_NODE')
              this.updateData()
            })
          }else{
            this.mindMap.updateData(data)
            this.activeData = {}
            this.editId = ''
          }
        })
      }
    }
  },
  mounted() {
  },
  methods: {
    updateMindMap() {
      if(this.mindMap) {
        this.mindMap.updateData(this.mindMapData)
      }
    },
    dialogBeforeClose() {
      this.$emit('closeDiaLog')
    },
    deleteMind() {
      this.mindMap.execCommand('REMOVE_NODE')
      this.mindMap.execCommand('CLEAR_ACTIVE_NODE')
      this.updateData()
    },
    addMind() {
      this.mindMap.execCommand('INSERT_NODE')
      this.updateData()
    },
    addChildMind() {
      this.mindMap.execCommand('INSERT_CHILD_NODE')
      this.updateData()
    },
    resetLayout() {
      this.mindMap.execCommand('RESET_LAYOUT')
    },
    exportImage() {
      this.mindMap.export('png')
    },
    updateData() {
      setMindMap(JSON.stringify(this.mindMap.getData()))
      this.$emit('mindMapUpdate', this.mindMap.getData())
    },
  }
}
</script>
<style lang="scss" scoped>
.dialog-content{
  position: relative;

  .button-list{
    position: absolute;
    top: 0;
    left: 0;
  }

  #mindMapContainer{
    width: 100%;
    height: 500px;

    /deep/.mind-map-item{
      padding: 5px 10px;
      font-size: 16px;
      line-height: 24px;
      max-width: 500px;
      border: 1px solid rgb(84, 150, 136);
      border-radius: 3px;
      user-select: text;

      .mind-map-item-selected{
        padding: 10px 16px;
        background: #f1f1f1;
        border: 1px dashed #4f678e;
        border-radius: 2px;
      }
    }

    /deep/.mind-map-item-main{
      color: #fff;
      font-weight: bold;
      background: rgb(84, 150, 136);
    }
  }

  .mind-map-bottom{
    position: absolute;
    bottom: 20px;
    right: 20px;
    padding: 5px;

    .icon{
      font-size: 20px;
    }
  }
}
/deep/.el-dialog{
  width: 65%;
  position: relative;
  margin: 0 auto 50px;
  background: #fff;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
  bottom: auto;
  left: auto;
  transform: none;
  display: block;
  
  .el-dialog__header{
    padding: 20px;
    padding-bottom: 10px;
    border: 0;

    .el-dialog__title{
      line-height: 24px;
      font-size: 18px;
      color: #303133;
    }
    .el-dialog__headerbtn{
      font-size: 20px;
      top: 20px;
      right: 20px;
    }
    .el-dialog__headerbtn:hover{
      .el-dialog__close{
        color: #0FC29A;
      }
    }
  }
  
  .el-dialog__body{
    padding: 30px 20px;
  }
}
</style>